import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/korean", label: "韩漫" },
    { to: "/category/japanese", label: "日漫" },
    { to: "/category/chinese", label: "国漫" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-flower-line text-lg text-white"></i>
            </div>
            <span className={`text-lg font-semibold transition-colors ${isScrolled ? 'text-foreground-950' : 'text-white'}`}>
              樱花漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                  location.pathname === link.to
                    ? isScrolled
                      ? "bg-primary-100 text-primary-700"
                      : "bg-white/20 text-white"
                    : isScrolled
                    ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${isScrolled ? '' : 'hidden'}`}>
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 w-48 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
            </div>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled
                ? "text-foreground-950 hover:bg-background-100"
                : "text-white hover:bg-white/10"
            }`}
          >
            <i className={`text-xl ${isMobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-2">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="pl-9 pr-4 py-2.5 w-full rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}